import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog-delete-confirm__title" }
const _hoisted_2 = { class: "dialog-delete-confirm__description" }
const _hoisted_3 = { class: "dialog-delete-confirm__description-name" }
const _hoisted_4 = { class: "dialog-delete-confirm__description-name" }
const _hoisted_5 = { class: "dialog-delete-confirm__actions" }

import { ref } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import { useConfirmKeys } from "@/composables/useConfirmKeys";


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogDeleteConfirm',
  props: {
    type: {},
    name: {}
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$root",
    ref: $root,
    class: "dialog-delete-confirm"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(props.type === 'chat' ? 'chat_delete_title' : 'chat_delete_group_title')), 1),
    _createElementVNode("div", _hoisted_2, [
      (props.type === 'chat')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$t('chat_delete_user_prefix')) + " ", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete_no_restore_suffix')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.$t('chat_delete_group_prefix')) + " ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.name), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete_no_restore_suffix')), 1)
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(AppButton, {
        class: "dialog-delete-confirm__actions-button",
        type: "secondary",
        label: _ctx.$t('cancel_short'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, null, 8, ["label"]),
      _createVNode(AppButton, {
        class: "dialog-delete-confirm__actions-button",
        label: _ctx.$t('confirm_short'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, null, 8, ["label"])
    ])
  ], 512))
}
}

})